<template lang="pug">
.k-booking-modal-review
  k-card-modal(
    v-if="booking"
    :value="value"
    :max-width="500"
  )
    template(v-slot:header-outer)
      k-card-text.overflow-hidden
        .title--regular.brand-dark-blue--text.font-weight-bold.font-family--secondary Leave a review

    k-booking-review(:booking="booking" :page-context="'modal'")
</template>

<script>
import { get } from 'vuex-pathify'
import { UsesAuthenticatedUser } from '@/mixins'

export default {
  mixins: [ UsesAuthenticatedUser ],
  props: {
    value: Boolean
  },
  computed: {
    ...get({
      booking: 'myKintell/awaitingBookingReview',
    }),
    reviewFor () {
      // fix some random bug where the booking advisor is null
      if (!this.booking) {
        return this.authenticatedUser
      }
      return (this.authenticatedUser.id === this.booking.advisor.id)
        ? this.booking.learner
        : this.booking.advisor
    },
  },
}
</script>
